export default __webpack_public_path__ + "static/064-f71d138d842cfa5bf32d087035a344f3.jpg";